import React, { useState } from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import "./style.scss";
import { useSimilaridadeSearch } from "../../hook/useSimilaridadeSearch";
import { useSearchPagination } from "../../contexts/Ncm&Gpc_context";
import { showError } from "../../services/toast";

interface IPageComboProperties {
  pageCount: number;
  onChangePage(event: any): void;
  disabled?: boolean;
}

interface IPaginationProps {
  rowsPerPage: number;
  rowCount: number;
  countSelected?: any;
  onChangePage: (page: number, totalRows: number) => void;
  onChangeRowsPerPage: (rowsPerPage: number, page: number) => void;
  currentPage: number;
  code?: string | number;
  hasConteudoLiquido?: boolean;
  hasMarca?: boolean; 
  onAfterSearch?: (result: any) => void;
  onRequireConfirmation?: (data: { filtros: any; raw: any }) => void;
  isDisabled: boolean;
  setIsDisabled: (disabled: boolean) => void;
}

function toPages(pages: number) {
  const results: number[] = [];
  for (let i = 1; i <= pages; i++) results.push(i);
  return results;
}

const PageCombo: React.FC<IPageComboProperties> = ({ pageCount, onChangePage, disabled }) => {
  const [isDisplay, setDisplay] = useState(false);
  const pages: number[] = [];
  for (let i = 1; i <= pageCount; i++) pages.push(i);

  return (
    <>
      <button
        className="page-link"
        onClick={() => !disabled && setDisplay(!isDisplay)}
        value="comboSelectPage"
        disabled={disabled}
      >
        ...
      </button>
      {isDisplay && (
        <select
          className="select"
          disabled={disabled}
          onChange={(e) => {
            setDisplay(false);
            onChangePage(e);
          }}
        >
          {pages.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      )}
    </>
  );
};

export const BootyPaginationSimilaridade: React.FC<IPaginationProps> = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage,
  currentPage,
  code,
  hasConteudoLiquido,
  hasMarca, 
  onAfterSearch,
  onRequireConfirmation,
  isDisabled,
  setIsDisabled
}) => {
  const pages = Math.ceil(rowCount / rowsPerPage);
  const pageItems = toPages(pages);

  const { loading, search } = useSimilaridadeSearch();
  const { selectedDatasetPage } = useSearchPagination();

  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1, rowCount);
  };

  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1, rowCount);
  };

  const handlePageNumber = (e: any) => {
    onChangePage(Number(e.target.value), rowCount);
  };

  const handleSearchClick = async () => {
    if (!selectedDatasetPage) {
      showError("Selecione pelo menos uma lista antes de pesquisar.");
      return;
    }

    setIsDisabled(true);
    await search({
      code,
      hasConteudoLiquido,
      hasMarca,
      pagina: selectedDatasetPage,
      onAfterSearch,
      onRequireConfirmation,
    });
    setIsDisabled(false);
  };

  return (
    <>
      {rowCount > 0 && (
        <nav className="datatablepaginationCustom">
          <div className="pageresults">
            <div className="shownumberperpage">
              Mostrar:
              <select
                onChange={(e) => onChangeRowsPerPage(Number(e.target.value), 1)}
                className="select"
                defaultValue={rowsPerPage}
                disabled={loading || isDisabled}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            {rowCount} resultados
          </div>

          <div className="containerPaginationAndButtonSearch">
            <ul className="custompagination">
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={handleBackButtonClick}
                  disabled={currentPage === 1 || loading || isDisabled}
                  aria-disabled={currentPage === 1 || loading || isDisabled}
                  aria-label="previous page"
                >
                  <FiArrowLeft style={{ fontSize: 20 }} />
                </button>
              </li>

              {pageItems.map((page) => {
                const className = page === currentPage ? "page-item active" : "page-item";

                return (
                  <div key={page} style={{ display: "contents" }}>
                    {page < 4 && (
                      <li className={className}>
                        <button
                          className="page-link"
                          onClick={handlePageNumber}
                          value={page}
                          disabled={loading || isDisabled}
                        >
                          {page}
                        </button>
                      </li>
                    )}

                    {page === Math.round(pageItems.length / 2) &&
                      pageItems.length > 6 &&
                      currentPage >= Math.round(pageItems.length / 2) && (
                        <li className="page-item">
                          <PageCombo
                            pageCount={pageItems.length}
                            onChangePage={handlePageNumber}
                            disabled={loading || isDisabled}
                          />
                        </li>
                      )}

                    {page === currentPage &&
                      page >= 4 &&
                      page <= pageItems.length - 3 && (
                        <li className={className}>
                          <button
                            className="page-link"
                            onClick={handlePageNumber}
                            value={page}
                            disabled={loading || isDisabled}
                          >
                            {page}
                          </button>
                        </li>
                      )}

                    {page === Math.round(pageItems.length / 2) &&
                      pageItems.length > 6 &&
                      currentPage < Math.round(pageItems.length / 2) && (
                        <li className="page-item">
                          <PageCombo
                            pageCount={pageItems.length}
                            onChangePage={handlePageNumber}
                            disabled={loading || isDisabled}
                          />
                        </li>
                      )}

                    {page >= 4 && page > pageItems.length - 3 && (
                      <li className={className}>
                        <button
                          className="page-link"
                          onClick={handlePageNumber}
                          value={page}
                          disabled={loading || isDisabled}
                        >
                          {page}
                        </button>
                      </li>
                    )}
                  </div>
                );
              })}

              <li className="page-item">
                <button
                  className="page-link page-end"
                  onClick={handleNextButtonClick}
                  disabled={currentPage === pageItems.length || loading || isDisabled}
                  aria-disabled={currentPage === pageItems.length || loading || isDisabled}
                  aria-label="next page"
                >
                  <FiArrowRight style={{ fontSize: 20 }} />
                </button>
              </li>
            </ul>

            <div className="containerButtonSearch">
              <button
                style={{ height: "42px", opacity: (loading || isDisabled || code == null) ? 0.6 : 1, cursor: (loading || isDisabled || code == null) ? 'not-allowed' : 'pointer' }}
                onClick={handleSearchClick}
                disabled={loading || isDisabled || code == null}
              >
                {loading ? "Pesquisar" : "Pesquisar"}
              </button>
            </div>
          </div>
        </nav>
      )}
    </>
  );
};

export const BootyPaginationSimilaridade2: React.FC<IPaginationProps> = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  countSelected,
  currentPage,
  code,
  hasConteudoLiquido,
  hasMarca, 
  onAfterSearch,
  onRequireConfirmation,
  isDisabled,
  setIsDisabled
}) => {
  const pages = Math.ceil(rowCount / rowsPerPage);
  const pageItems = toPages(pages);

  const { loading, search } = useSimilaridadeSearch();
  const { selectedDatasetPage } = useSearchPagination();

  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1, rowCount);
  };

  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1, rowCount);
  };

  const handlePageNumber = (e: any) => {
    onChangePage(Number(e.target.value), rowCount);
  };

  const handleSearchClick = async () => {
    if (!selectedDatasetPage) {
      showError("Selecione pelo menos uma lista antes de pesquisar.");
      return;
    }

    setIsDisabled(true);
    await search({
      code,
      hasConteudoLiquido,
      hasMarca, 
      pagina: selectedDatasetPage,
      onAfterSearch,
      onRequireConfirmation,
    });
    setIsDisabled(false);
  };

  return (
    <>
      {rowCount > 0 && (
        <nav
          className={`datatablepaginationCustom2 ${
            countSelected > 0 ? "pagination-selected" : ""
          }`}
        >
          <div>
            <span
              style={{
                color: "#fff",
                fontSize: "15px",
                fontWeight: 500,
                marginLeft: "22px",
              }}
            >
              <span
                style={{
                  marginRight: "20px",
                  color: countSelected > 0 ? "#fff" : "#262626",
                }}
              >
                {countSelected === 0 || !countSelected
                  ? "Nenhuma lista selecionada"
                  : countSelected === 1
                  ? "1 lista selecionada"
                  : `${countSelected} listas selecionadas`}
              </span>
            </span>
          </div>

          <div className="containerPaginationAndButtonSearch">
            <div
              className="pageresults"
              style={{
                marginRight: "20px",
                color: countSelected > 0 ? "#fff" : "#262626",
              }}
            >
              {rowCount} resultados
            </div>

            <ul className="custompagination">
              <li className="page-item">
                <button
                  className="page-link"
                  onClick={handleBackButtonClick}
                  disabled={currentPage === 1 || loading || isDisabled}
                  aria-disabled={currentPage === 1 || loading || isDisabled}
                  aria-label="previous page"
                >
                  <FiArrowLeft style={{ fontSize: 20 }} />
                </button>
              </li>

              {pageItems.map((page) => {
                const className = page === currentPage ? "page-item active" : "page-item";

                return (
                  <div key={page} style={{ display: "contents" }}>
                    {page < 4 && (
                      <li className={className}>
                        <button
                          className="page-link"
                          onClick={handlePageNumber}
                          value={page}
                          disabled={loading || isDisabled}
                        >
                          {page}
                        </button>
                      </li>
                    )}

                    {page === Math.round(pageItems.length / 2) &&
                      pageItems.length > 6 &&
                      currentPage >= Math.round(pageItems.length / 2) && (
                        <li className="page-item">
                          <PageCombo
                            pageCount={pageItems.length}
                            onChangePage={handlePageNumber}
                            disabled={loading || isDisabled}
                          />
                        </li>
                      )}

                    {page === currentPage &&
                      page >= 4 &&
                      page <= pageItems.length - 3 && (
                        <li className={className}>
                          <button
                            className="page-link"
                            onClick={handlePageNumber}
                            value={page}
                            disabled={loading || isDisabled}
                          >
                            {page}
                          </button>
                        </li>
                      )}

                    {page === Math.round(pageItems.length / 2) &&
                      pageItems.length > 6 &&
                      currentPage < Math.round(pageItems.length / 2) && (
                        <li className="page-item">
                          <PageCombo
                            pageCount={pageItems.length}
                            onChangePage={handlePageNumber}
                            disabled={loading || isDisabled}
                          />
                        </li>
                      )}

                    {page >= 4 && page > pageItems.length - 3 && (
                      <li className={className}>
                        <button
                          className="page-link"
                          onClick={handlePageNumber}
                          value={page}
                          disabled={loading || isDisabled}
                        >
                          {page}
                        </button>
                      </li>
                    )}
                  </div>
                );
              })}

              <li className="page-item">
                <button
                  className="page-link page-end"
                  onClick={handleNextButtonClick}
                  disabled={currentPage === pageItems.length || loading || isDisabled}
                  aria-disabled={currentPage === pageItems.length || loading || isDisabled}
                  aria-label="next page"
                >
                  <FiArrowRight style={{ fontSize: 20 }} />
                </button>
              </li>
            </ul>

            <div className="containerButtonSearch">
              <button
                style={{ height: "42px", opacity: (loading || isDisabled || code == null) ? 0.6 : 1, cursor: (loading || isDisabled || code == null) ? 'not-allowed' : 'pointer' }}
                onClick={handleSearchClick}
                disabled={loading || isDisabled || code == null}
              >
                {loading ? "Pesquisar" : "Pesquisar"}
              </button>
            </div>
          </div>
        </nav>
      )}
    </>
  );
};

export default BootyPaginationSimilaridade;